import { Injectable } from '@angular/core';
import { BranchTypesService } from '../../branch-types/logic/branch-types.service';
import { BranchesService } from '../../branches/logic/branches.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { TourStopsService } from '../../tour-stop/logic/tour-stop.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { TourService } from '../../tour/logic/tour.service';
import { OrderItemsService } from '../../order-item/logic/order-item.service';
import { OrderItemType } from 'src/app/_model/order-item';

@Injectable({
  providedIn: 'root',
})
export class HasReturnItemsVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'hasReturnItems';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private tourStopsService: TourStopsService,
    private orderItemsService: OrderItemsService
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    const tourStopId = this.clientStateService.theState.getValue().tourStopId;

    if (tourStopId == undefined) {
      return false;
    }

    const tourStop = this.tourStopsService.getTourStopById(tourStopId);

    if (tourStop == undefined) {
      return false;
    }

    for (const servicejobId of tourStop.servicejobIds) {
      const orderItems = this.orderItemsService.getOrderItemsByServicejobId(servicejobId);
      for (const orderItem of orderItems) {
        if (orderItem.type === OrderItemType.RETURN) {
          return true;
        }
      }
    }

    return false;
  }

  // Private Functions
}
